import type { ComponentProps } from "react";
import logo2x from "@/assets/logo@2x.png";
import logo3x from "@/assets/logo@3x.png";
import logo from "@/assets/logo.png";
import { cn } from "@/lib/utils";

type LogoProps = Omit<ComponentProps<"img">, "src" | "srcSet">;

export default function Logo({ alt = "OS04", className, ...props }: LogoProps) {
  return (
    <img
      src={logo}
      srcSet={`${logo} 1x, ${logo2x} 2x, ${logo3x} 3x`}
      alt={alt}
      className={cn("h-auto max-h-12 py-2", className)}
      {...props}
    />
  );
}
